module.exports = __webpack_public_path__ + "static/media/logo_mk.c57066a7.svg";